module.exports = __webpack_public_path__ + "img/t7-6.5dded199.svg";